import React from 'react'
import Radio from 'material-ui/Radio'

const RowRadioButton = ({ value, state, changeHandler, key }) => {
  return (
    <Radio
      checked={state === true ? true : false}
      onClick={changeHandler}
      value={value}
      key={key}
    />
  )
}

export default RowRadioButton



// WEBPACK FOOTER //
// ./src/components/table/cells/rowRadioButton/index.js